import { getFolders, storeOrUpdateMaterial } from '@/api/local-material'
import UploadFile from '@/components/upload-file/UploadFile.vue'
import OssUpload from '@/components/oss-upload/OssUpload.vue'
import ImageUpload from '@/components/image-upload/ImageUpload.vue'
import { getMaterialTags,getWorkers } from '@/api/open'

export default {
    components: {
        UploadFile,
        ImageUpload,
        OssUpload
    },
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    created() {
        if (this.model.id) {
            if (this.model.action == 'move') {
                this.actionName = '移动'
            } else if (this.model.action == 'copy') {
                this.actionName = '复制'
            } else {
                this.actionName = '修改'
            }
        } else {
            this.actionName = '添加'
        }
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            rules: {
                name: [{ required: true, message: '请填写素材名称', trigger: 'change' }],
                pid: [{ required: true, message: '请选择所属目录', trigger: 'change' }],
                file_url: [{ required: true, message: '请上传文件', trigger: 'change' }],
                worker_id: [{ required: true, message: '请选择上传人', trigger: 'change' }],
            },
            actionName: '操作',
            titles: [],
            show: false,
            treeData: [],
            replaceFields: {
                title: 'name',
                key: 'id',
                value: 'id'
            },
            showSize: 0,
            pid: null,
            materials: [], //上传的多个素材
            materialTags: [],
            workers:[],
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
        //获取所有的目录
        getFolders().then(res => { this.treeData = res.data.list || {} })
        if (this.model.size) {
            this.showSize = Number(this.model.size / 1024 / 1024).toFixed(2)
        }
        getMaterialTags().then(res => { this.materialTags = res.data.list || {} })
        getWorkers({type:3}).then(res => {
            this.workers = res.data.list
        })
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            const data = Object.assign({}, this.model)
            if (this.model.action) {
                data.pid = this.pid
            }

            if (!data.pid) {
                return this.$message.error('素材禁止' + this.actionName + '到根目录')
            }
            data.materials = this.materials
            // console.log('提交的数据', data)

            this.loading = true
            storeOrUpdateMaterial(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.actionName + '成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            // this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        },
        handleAfterUpload(data) {
            // 在这里处理从子组件返回的数据
            // console.log('上传后返回的数据', data);
            this.materials = []

            if (Array.isArray(data)) {
                data.forEach(element => {
                    const thisData = {};
                    thisData.size = element.fileSize
                    this.showSize = Number(element.fileSize / 1024 / 1024).toFixed(2)
                    thisData.type = element.type
                    thisData.width = element.width
                    thisData.height = element.height
                    thisData.name = element.originalFilename
                    thisData.code = element.md5Code
                    thisData.video_cover = element.video_cover
                    thisData.file_url = element.url
                    this.materials.push(thisData)
    
                    this.model.size = element.fileSize
                    this.model.type = element.type
                    this.model.width = element.width
                    this.model.height = element.height
                    this.model.name = element.originalFilename
                    this.model.code = element.md5Code
                    this.model.video_cover = element.video_cover
                    this.model.file_url = element.url
                });
            } else {
                this.model.size = null
                this.model.type = null
                this.model.width = null
                this.model.height = null
                this.model.name = null
                this.model.code = null
                this.model.video_cover = null
            }
            
  
            // console.log('最终的materials数据', this.materials);

        }
    }
}
